import { sharedIconPaths } from "./shared-icon-paths"

export const unitIconPaths: Record<string, string> = {
  "unit.escalator": sharedIconPaths["escalator"],
  "unit.elevator": sharedIconPaths["elevator"],
  "unit.stairs": sharedIconPaths["stairs"],
  "unit.stairs.emergencyexit": sharedIconPaths["stairs.emergencyexit"],
}
